export default "__VITE_ASSET__CXAk1Izm__"